import { carouselList } from './Carousel'
import { isMobile } from '../lib/helpers'

addEventListener('DOMContentLoaded', () => {
	const header = document.body.querySelector('header')
	const topMenu = header.querySelector('nav#top')
	const heroContent = [...document.body.querySelectorAll('.hero-content')] // Optional.

	const onScroll = () => {
		const y = Math.max(0, window.scrollY || window.pageYOffset || document.body.scrollTop)
		for (const carousel of carouselList) {
			carousel.setOffset(y)
		}

		// Effects for the header and potential hero content.
		const SCROLL_SCALE = innerHeight / 4
		const offset = Math.min(y, SCROLL_SCALE) / SCROLL_SCALE

		const elements = [topMenu, ...heroContent]
		for (const element of elements) {
			if (element) {
				element.style.opacity = 1 - offset
				//element.style.filter = `blur(${offset * 4}px)`
			}
		}

		// Header slide out.
		if (!isMobile()) {
			const clientHeight = document.documentElement.clientHeight
			const maxHeight = (clientHeight * 0.50) - 125
			if (y >= maxHeight) {
				header.classList.add('move')
			} else if (header.classList.contains('move')) {
				header.classList.remove('move')
			}
		}
	}

	addEventListener('scroll', onScroll)
	onScroll()
})
